import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  populateWithFiles,
  storeFilesInStorage,
} from "../../../components/forms/storage";
import { AppStore } from "../../../store";
import { LaunchConfigurationsDTO } from "../../../store/launch-configurations/models/dto";
import { LaunchesActions } from "../../../store/launches/actions";
import { LaunchesDTO } from "../../../store/launches/models/dto";

type FormType = LaunchesDTO.Requests.ParticipationForm.ForForm;

/**
 * This hook will take a list of fields and return form hook for them.
 * It takes care for outer form state and validation as well as persistance
 * throughout the steps.
 */
export function useDataInRedux<T extends keyof FormType>(
  item: LaunchConfigurationsDTO.Responses.GetSingle.T,
  defaults?: Partial<FormType>
) {
  const dispatch = useDispatch();

  const storedData = useSelector<
    AppStore,
    AppStore["launches"]["newParticipationForm"][string]
  >((store) => store.launches.newParticipationForm[item.id]);

  const persistInStorage = useCallback(
    (x: FormType[T]) => {
      const foo = storeFilesInStorage(x);
      dispatch(
        LaunchesActions.setParticipationForm({
          id: item.id,
          data: foo,
        })
      );
    },
    [storeFilesInStorage]
  );

  const data = useMemo(() => {
    return { ...defaults, ...populateWithFiles(storedData) };
  }, [storedData, defaults]);

  return { data, persistInStorage };
}
